import React from 'react'
import {Button, Row, Col, Glyphicon, FormControl, Dropdown} from 'react-bootstrap'
import {CSVLink} from "react-csv";
import {MultiSelect} from "react-multi-select-component";
import moment from "moment";
import InlineForm from "../Elements/FromGroup/InlineForm"
import AscComponent from '../../components/AscComponent'
import CommonTable from '../../containers/Elements/Table/CommonTable'
import UserModal from './UserModal'
import UserCsvInsertModal from './UserCsvInsertModal'
import ErrorMessageModal from "../Elements/AscElements/ErrorMessageModal";
import * as GlobalConst from '../../components/AscConstants';
import AscConfirm from '../../components/Modal/AscConfirm';

export default class User extends AscComponent {
    constructor(props) {
        super(props)
        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            filtered: [],
            pages: null,
            loading: false,

            // modal item
            show: false,
            modalType: null,

            // select item
            companySelect: [],
            departmentSelect: [],
            floorSelect: [],

            // data item
            userId:         '',
            company_id:     '',
            companyName:    '',
            department_id:  '',
            department_name: '',
            department_prefix: '',
            floor_id:       '',
            floor_name:     '',
            mailAddress:    '',
            firstNameCc:    '',
            lastNameCc:     '',
            firstNameKana:  '',
            lastNameKana:   '',
            password:       '',
            passwordRe:     '',
            oldPassword:    '',
            newPassword:    '',
            newPasswordRe:  '',
            downloadflag:   '',
            passwordResetFlag: false,
            // button_disabled
            buttondisabledArr: {
                "company_id" : [],
                "department_id" : [],
                "floor_id" : [],
                "department_load": [],
                "floor_load" : []
            },
            permissionSelect: [],
            loginLockFlag: false,
            csvFile: false,
            errorMessageModalShow: false,
            csvInsertLoadingFlag: false,
            user_affiliation_flag: false,
            
            // CSV登録時のポップアップオプション管理
            csvPopupOptions: null,
            requiresPopup: false,

            csvExportCompanyId: this.props.userInfo.company_id,
            csvExportDepartmentId: [],
            csvExportFloorId: [],
            csvExportData: [],
            csvExportDepartmentSelect: [],
            csvExportFloorSelect: [],
            csvExportValidationMessage: [],

            // CSVヘッダー(インポート)
            headerJson : [
                {
                    label: this.props.langText.Body.EmailAddress,
                    key: "mailAddress",
                    required: true
                },
                {
                    label: this.props.langText.Body.FirstNameCc + 
                    "(" + this.props.langText.Body.ChineseCharacter + ")",
                    key: "firstNameCc",
                    required: true
                },
                {
                    label: this.props.langText.Body.LastNameCc + 
                    "(" + this.props.langText.Body.ChineseCharacter + ")",
                    key: "lastNameCc",
                    required: true
                },
                {
                    label: this.props.langText.Body.FirstNameKana + 
                    "(" + this.props.langText.Body.Katakana + ")",
                    key: "firstNameKana",
                    required: false
                },
                {
                    label: this.props.langText.Body.LastNameKana + 
                    "(" + this.props.langText.Body.Katakana + ")",
                    key: "lastNameKana",
                    required: false
                },
                {
                    label: this.props.langText.Body.Password,
                    key: "password",
                    required: true
                },
                {
                    label: this.props.langText.Body.PermissionName,
                    key: "permission",
                    required: true
                }
            ],
            // CSVヘッダー(エクスポート)
            csvHeaderExport: [],

            // 追加確認ポップアップ表示のON/OFF
            isSetShowAddingConfirmationPopup: false,
            showConfirm: false,
            confirmMemo: "",
            confirmValue: "",

            // CSV登録用データ保存
            csvInsertData: [],

            // デバッグ用
    
        }
        // csvヘッダ定義(インポート)
        this.headerJson = [
            {
                label: this.props.langText.Body.EmailAddress,
                key: "mailAddress",
                required: true
            },
            {
                label: this.props.langText.Body.FirstNameCc + 
                "(" + this.props.langText.Body.ChineseCharacter + ")",
                key: "firstNameCc",
                required: true
            },
            {
                label: this.props.langText.Body.LastNameCc + 
                "(" + this.props.langText.Body.ChineseCharacter + ")",
                key: "lastNameCc",
                required: true
            },
            {
                label: this.props.langText.Body.FirstNameKana + 
                "(" + this.props.langText.Body.Katakana + ")",
                key: "firstNameKana",
                required: false
            },
            {
                label: this.props.langText.Body.LastNameKana + 
                "(" + this.props.langText.Body.Katakana + ")",
                key: "lastNameKana",
                required: false
            },
            {
                label: this.props.langText.Body.Password,
                key: "password",
                required: true
            },
            {
                label: this.props.langText.Body.PermissionName,
                key: "permission",
                required: true
            }
        ];

        // csvヘッダ定義(エクスポート)
        this.csvHeaderExport = [
            // メールアドレス
            {
                label: this.props.langText.Body.EmailAddress,
                key: "EmailAddress"
            },
            // 会社名
            {
                label: this.props.langText.Body.CompanyName,
                key: "CompanyName"
            },
            // 拠点名
            {
                label: this.props.langText.Body.DepartmentName,
                key: "DepartmentName"
            },
            // フロア名
            {
                label: this.props.langText.Body.FloorName,
                key: "FloorName"
            },
            // 姓(漢字)
            {
                label: this.props.langText.Body.UserCsvExportListHeaderFirstName,
                key: "FirstName"
            },
            // 名(漢字)
            {
                label: this.props.langText.Body.UserCsvExportListHeaderLastName,
                key: "LastName"
            },
            // セイ(カタカナ)
            {
                label: this.props.langText.Body.UserCsvExportListHeaderFirstNameKana,
                key: "FirstNameKana"
            },
            // メイ(カタカナ)
            {
                label: this.props.langText.Body.UserCsvExportListHeaderLastNameKana,
                key: "LastNameKana"
            },
            // 権限名
            {
                label: this.props.langText.Body.UserCsvExportListHeaderPermissionName,
                key: "PermissionName"
            }
        ]
        this.floor_load_flag = false;
        this.csvReaderRef = React.createRef();
    }

    componentDidMount = async () => {
        // 追加確認ポップアップ表示の対象画面であるか
        try {
            const result = await this.ascAxios("post", `Common/getShowAddingConfirmationPopupTargetPage`);
            this.isTargetShowAddingConfirmationPopup = result.data.includes(this.reactContainerPath.split("/").pop());
        } catch (err) {
            console.error(err);
            this.isTargetShowAddingConfirmationPopup = false;
        }

        // 既存の初期化処理
        // csv出力権限がある場合、会社・拠点・フロアリストを取得
        if (this.props.currentPermission.export) {
            if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
                // OEM管理者権限以上の場合、会社一覧を取得
                await this.getCompanySelect();
            }
            if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
                // 会社管理者権限以上の場合、拠点一覧を取得
                await this.setCommonDepartmentSelect(this.state.csvExportCompanyId, this.props.userInfo.floor_flg);
            } else if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department) && this.props.userInfo.floor_flg) {
                // 拠点管理者権限以上かつフロア有の場合、フロア一覧を取得
                await this.setCommonFloorSelect(this.props.userInfo.parent_department_id);
            }
        }
    }

    getColumnsData() {
        let itemArr = [];

        // oem以上は会社カラム表示
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            itemArr.push({
                Header: this.props.langText.Body.CompanyName,
                accessor: 'cm12_companies.company_name',
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm12_companies.company_name")} />
            });
        }

        // company以上は拠点カラム表示
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
            itemArr.push({
                Header: this.props.langText.Body.DepartmentName,
                accessor: 'cm13_departments.department_name',
                width: this.props.boardWidth.medium,
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm13_departments.department_name")} />
            });
        }

        if (
            (this.props.systemParameters.SYSTEM_FLOOR_FLG === "Y" &&
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.system)) ||
            (this.props.userInfo.floor_flg &&
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department))
        ) {
            itemArr.push({
                Header: this.props.langText.Body.FloorName,
                accessor: 'cm13_departments.floor_name',
                width: this.props.boardWidth.medium,
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm13_departments.floor_name")} />
            });
        }

        itemArr.push({
            Header: this.props.langText.Body.EmailAddress,
            accessor: 'mail_address',
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "mail_address")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.UserName,
            accessor: 'user_name_sei',
            filterable: false,
            width: this.props.boardWidth.medium,
            Cell: data => {
                return `${data.row._original.user_name_sei} ${data.row._original.user_name_mei}`
            },
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "user_name_sei")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.Auth,
            accessor: 'cm73_permissions.name',
            width: this.props.boardWidth.medium,
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm73_permissions.name")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.LastLoginDate,
            filterable: false,
            width: this.props.boardWidth.Date,
            accessor: 'ct90_login_histories.created',
            Cell: data => {
                let returnData = (
                    data.row._original.ct90_login_histories
                    && data.row._original.ct90_login_histories.created)
                    ? this.getMomentTime({
                        date:   data.row._original.ct90_login_histories.created,
                        format: this.props.langText.Body.DateFormat
                        })
                    : ''

                return returnData
            }
        });

        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
            // 会社管理者以上の場合、「ロック状態」列を表示
            itemArr.push({
                Header: this.props.langText.Body.UserLockedFlag,
                filterable: false,
                accessor: 'login_failure_count',
                width: this.props.boardWidth.medium,
                Cell: data => {
                    let returnData = (
                        data.row._original.login_failure_count >= this.props.systemParameters.CUSCON_LOGIN_FAILURE_COUNT_MAX
                            ? { label: this.props.langText.Body.UserLockedStatus, style: {color: "red"} }
                            : { label: "" }
                    )
                    return [
                        <div className="user_locked_status" style={returnData.style}>
                            {returnData.label}
                        </div>
                    ];
                }
            });
        }

        itemArr.push({
            Header: this.props.langText.Body.Control,
            filterable: false,
            sortable: false,
            width: this.props.boardWidth.LargeControl,
            Cell: data => {
                // 権限に応じて各アイコン表示
                let rowData = [];
                // 編集権限あれば編集ボタン、編集権限無ければ閲覧ボタン
                if (this.props.currentPermission.edit) {
                    rowData.push(
                        <Button
                            key={0}
                            bsSize="xsmall"
                            className="control-button"
                            onClick={this.modalShow("update", data.row._original)}
                        >
                            <Glyphicon glyph="pencil"/>
                        </Button>
                    );
                } else {
                    rowData.push(
                        <Button
                            key={0}
                            bsSize="xsmall"
                            className="control-button"
                            onClick={this.modalShow("read", data.row._original)}
                        >
                            <Glyphicon glyph="eye-open"/>
                        </Button>
                    );
                }
                if (this.props.currentPermission.create) {
                    rowData.push(
                        <Button
                            key={1}
                            bsSize="xsmall"
                            className="control-button"
                            onClick={this.modalShow("copy", data.row._original)}
                        >
                            <Glyphicon glyph="copy"/>
                        </Button>
                    );
                }
                if (this.props.currentPermission.delete) {
                    rowData.push(
                        <Button
                            key={2}
                            bsSize="xsmall"
                            className="control-button"
                            onClick={this.modalShow("delete", data.row._original)}
                        >
                            <Glyphicon glyph="minus"/>
                        </Button>
                    );
                }

                return (
                    <Row className="text-center">
                        {rowData}
                    </Row>
                );
            }
        });

        return itemArr;
    }

    // 画面表示タイミング共通処理_変数初期化
    modalshow_commonInit() {
        this.setState({
            buttondisabledArr: {
                "company_id" : [],
                "department_id" : [],
                "floor_id" : [],
                "department_load": [],
                "floor_load" : []
            }
        });
    };

    common_buttondisabledLengthCheck = (param,switchdata) => {
        switch (switchdata)
        {
            case `push`:
                if(this.state.buttondisabledArr[param].length === 0)
                {
                    this.state.buttondisabledArr[param].push("dataset");
                }
            break;
            case `pop`:
                this.state.buttondisabledArr[param].pop();
            break;
            default:
                console.log("common_buttondisabledLengthCheck_switchErr");
            break;
        }
    }

    // テンプレートの成型
    moldCsvHeader = (user_affiliation_flag) => {
        let mold_Array = this.headerJson;
            if (!user_affiliation_flag) {
                //OEM管理者以上
                let oemArray = 
                [
                    // 会社名
                    {
                        label: this.props.langText.Body.CompanyName,
                        key: "companyName",
                        required: true
                    },
                    // 拠点名
                    {
                        label: this.props.langText.Body.DepartmentName,
                        key: "departmentName",
                        required: true
                    }
                ];

                //会社管理者以上
                let companyArray = 
                [
                    // 拠点名
                    {
                        label: this.props.langText.Body.DepartmentName,
                        key: "departmentName",
                        required: true
                    }
                ];

                //拠点管理者以上
                let departmentArray = [];



                if (
                    (this.props.systemParameters.SYSTEM_FLOOR_FLG === "Y" &&
                        this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.system)) ||
                    (this.props.userInfo.floor_flg &&
                        this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department))
                ) {
                    //OEM管理者以上
                    oemArray = 
                    [
                        // 会社名
                        {
                            label: this.props.langText.Body.CompanyName,
                            key: "companyName",
                            required: true
                        },
                        // 拠点名
                        {
                            label: this.props.langText.Body.DepartmentName,
                            key: "departmentName",
                            required: true
                        },
                        // フロア名
                        {
                            label: this.props.langText.Body.FloorName,
                            key: "floorName",
                            required: true
                        }
                    ];

                    //会社管理者以上
                    companyArray = 
                    [
                        // 拠点名
                        {
                            label: this.props.langText.Body.DepartmentName,
                            key: "departmentName",
                            required: true
                        },
                        // フロア名
                        {
                            label: this.props.langText.Body.FloorName,
                            key: "floorName",
                            required: true
                        }
                    ];

                    //拠点管理者以上
                    departmentArray = 
                    [
                        // フロア名
                        {
                            label: this.props.langText.Body.FloorName,
                            key: "floorName",
                            required: true
                        }
                    ];
                }
                
                //OEM管理者以上
                if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
                    mold_Array = [...oemArray,...this.headerJson];
                //会社管理者以上
                }else if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
                    mold_Array = [...companyArray,...this.headerJson];
                //拠点管理者以上
                }else if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department) && this.props.userInfo.floor_flg) {
                    mold_Array = [...departmentArray,...this.headerJson];
                }
            }
        return mold_Array;
    }

    createExportCsvData = async () => {
        let {
            csvExportCompanyId,
            csvExportDepartmentId,
            csvExportFloorId,
            csvExportDepartmentSelect,
            csvExportFloorSelect
        } = this.state;
        try {
            this.unblockUI();
            this.setState({ loading: true });

            let reqBody = {
                sorted: [ { id: 'id', desc: true } ],
                filtered: []
            }

            // OEM管理者権限以上の場合、cm12の条件を指定
            if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
                reqBody.filtered.push(
                    {
                        id: 'cm12_companies.id',
                        value: csvExportCompanyId
                    }
                )
            }

            let csv_department_ids = csvExportDepartmentId.map(row => {return row.value});

            // 「拠点」もしくは「フロア」が全選択以外の場合のみ、cm13の条件を指定
            if (
                (csvExportDepartmentId.length !== csvExportDepartmentSelect.length) ||
                (csvExportFloorId.length !== csvExportFloorSelect.length))
            {
                if ((csvExportFloorId && csvExportFloorId.length > 0)) {
                    csvExportFloorId.forEach(row => {
                        csv_department_ids.push(row.value);
                    });
                }
                reqBody.filtered.push(
                    {
                        id: 'cm13_departments.id',
                        value: csv_department_ids
                    }
                );
            }

            let header = this.csvHeaderExport;
            this.csvHeaderExport.forEach(row => {
                // 権限によって、表示カラムを制御
                switch (row.key) {
                    case "CompanyName":
                        // 会社管理者以下の権限であれば、「会社名」は非表示にする
                        if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
                            header = header.filter(elem => elem.key !== row.key);
                        }
                        break;
                    case "DepartmentName":
                        // 拠点管理者以下の権限であれば、「拠点名」は非表示にする
                        if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.department)) {
                            header = header.filter(elem => elem.key !== row.key);
                        }
                        break;
                    case "FloorName":
                        // 拠点に紐づくフロアが存在しない場合
                        // またはフロア管理者権限以下である場合、「フロア名」は非表示にする
                        if (
                            csvExportFloorId.length === 0
                            || this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.floor)
                        ) {
                            header = header.filter(elem => elem.key !== row.key);
                        }

                        break;
                    default:
                        break;
                }
            });

            const result = await this.ascAxios(
                "post",
                `${this.reactContainerPath}/getExportCsvData`,
                reqBody
            );

            let csvExportData = [];
            if (result.data.length > 0) {
                for (const row of result.data) {
                    let csvDataRow = {};

                    csvDataRow.EmailAddress = row.mail_address
                        ? row.mail_address
                        : ""
                    ;

                    // OEM管理者権限以上である場合、会社名を表示
                    if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
                        csvDataRow.CompanyName = row.cm12_companies.company_name
                            ? row.cm12_companies.company_name
                            : ""
                        ;
                    }

                    // 会社管理者権限以上である場合、拠点名を表示
                    if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
                        csvDataRow.DepartmentName = row.cm13_departments.department_name
                            ? row.cm13_departments.department_name
                            : ""
                        ;
                    }

                    // 拠点に紐づくフロアが1個以上存在する場合
                    // かつ拠点管理者権限以上である場合、フロア名を表示
                    if (
                        csvExportFloorId.length > 0
                        && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department)
                    ) {
                        csvDataRow.FloorName = row.cm13_departments.floor_name
                            ? row.cm13_departments.floor_name
                            : ""
                        ;
                    }

                    csvDataRow.FirstName = row.user_name_sei
                        ? row.user_name_sei
                        : ""
                    ;

                    csvDataRow.LastName = row.user_name_mei
                        ? row.user_name_mei
                        : ""
                    ;

                    csvDataRow.FirstNameKana = row.user_name_kana_sei
                        ? row.user_name_kana_sei
                        : ""
                    ;

                    csvDataRow.LastNameKana = row.user_name_kana_mei
                        ? row.user_name_kana_mei
                        : ""
                    ;

                    csvDataRow.PermissionName = row.cm73_permissions.name
                        ? row.cm73_permissions.name
                        : ""
                    ;

                    csvExportData.push(csvDataRow);
                }
            }

            this.setState({
                csvExportData,
                csvHeaderExport: header,
                loading: false
            });

            if (csvExportData.length === 0) {
                return this.showErrorObjectMesssage({ message: "Download_Failed" });
            } else {
                return this.csvReaderRef.current.link.click();
            }
        } catch (err) {
            this.setState({ loading: false });
            console.log(err);
        } finally {
            this.unblockUI();
        }
    };

    modalShow = (modalType, param) => async event => {
        event.preventDefault()

        this.floor_load_flag = false;
        // 条件配列の初期化
        this.modalshow_commonInit();

        let setData = {
            userId: param && param.id
                ? param.id
                : '',
            company_id: param && param.cm12_companies && param.cm12_companies.id
                ? param.cm12_companies.id
                : '',
            companyName: param && param.cm12_companies && param.cm12_companies.company_name
                ? param.cm12_companies.company_name
                : '',
            floor_flg: param && param.cm12_companies && param.cm12_companies.floor_flg
                ? param.cm12_companies.floor_flg === "Y"
                : null,
            department_id: param && param.cm13_departments && param.cm13_departments.id
                ? param.cm13_departments.id
                : '',
            department_name: param && param.cm13_departments && param.cm13_departments.department_name
                ? param.cm13_departments.department_name
                : '',
            department_prefix: param && param.cm13_departments && param.cm13_departments.department_prefix
                ? param.cm13_departments.department_prefix
                : '',
            floor_id: param && param.cm13_departments && param.cm13_departments.id
                ? param.cm13_departments.id
                : '',
            floor_name: param && param.cm13_departments && param.cm13_departments.floor_name
                ? param.cm13_departments.floor_name
                : '',
            mailAddress: param && param.mail_address
                ? param.mail_address
                : '',
            firstNameCc: param && param.user_name_sei
                ? param.user_name_sei
                : '',
            lastNameCc: param && param.user_name_mei
                ? param.user_name_mei
                : '',
            firstNameKana: param && param.user_name_kana_sei
                ? param.user_name_kana_sei
                : '',
            lastNameKana: param && param.user_name_kana_mei
                ? param.user_name_kana_mei
                : '',
            password: '',
            passwordRe: '',
            oldPassword: '',
            newPassword: '',
            newPasswordRe: '',
            permission_id: param && param.cm73_permissions.id
                ? param.cm73_permissions.id
                : '',
            permission_name: param && param.cm73_permissions.name
                ? param.cm73_permissions.name
                : '',
            permissionSelectLoad: true,
            passwordResetFlag: false,
            user_affiliation_flag: false,
            headerJson: this.moldCsvHeader(false),
            csvInsertData: [],
            showConfirm: false,
            confirmMemo: "",
            confirmValue: ""
        }

        // CSV登録以外の場合の会社・拠点・フロア設定
        if (!param && modalType !== 'csvInsert') {
        // 新規作成時にcompany以下なら会社固定
            if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
                setData.company_id = this.props.userInfo.company_id
                setData.companyName = this.props.userInfo.company_name
                setData.floor_flg = this.props.userInfo.floor_flg
            }
            // 新規作成時にdepartment以下なら拠点固定
            if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.department)) {
                if (this.props.userInfo.floor_flg) {
                    setData.department_id = this.props.userInfo.parent_department_id
                    setData.department_name = this.props.userInfo.parent_department_name
                    setData.department_prefix = this.props.userInfo.department_prefix
                } else {
                    setData.department_id = this.props.userInfo.department_id
                    setData.department_name = this.props.userInfo.department_name
                }
            }
            // 新規作成時にfloor以下ならフロア固定
            if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.floor)) {
                setData.floor_id = this.props.userInfo.department_id
                setData.floor_name = this.props.userInfo.floor_name
            }
        }

        // CSV登録時の会社ID設定
        if (modalType === 'csvInsert') {
            // 追加確認ポップアップ設定取得のため、常にログインユーザーの会社IDを使用
            setData.company_id = this.props.userInfo.company_id;
            setData.companyName = this.props.userInfo.company_name;
            setData.floor_flg = this.props.userInfo.floor_flg;
            
            // CSV登録のポップアップオプションをリセット
            setData.csvPopupOptions = null;
            setData.requiresPopup = false;
            setData.isSetShowAddingConfirmationPopup = false;
        }

        setData.loginLockFlag = (
            modalType === "update" &&
            this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company) &&
            param &&
            param.login_failure_count >= this.props.systemParameters.CUSCON_LOGIN_FAILURE_COUNT_MAX
        );

        // 追加確認ポップアップ設定を取得
        setData.isSetShowAddingConfirmationPopup =
                setData.company_id !== ""
                    ? await this.getIsShowAddingConfirmationPopup(setData.company_id)
                    : false
                ;

        // 確認キーアイテムを設定
        setData.confirmKeyItem = await this.getConfirmKeyItem(modalType);

        this.setState(setData)

        this.setPermissionSelect(setData.company_id, setData.floor_flg)

        this.getCompanySelect()
        this.getDepartmentSelect(setData, "update")
        this.getFloorSelect(setData)

        this.setState({show: true, modalType})
    }

    onClickHandle = modalType => async event => {
        let {
            userId,
            company_id,
            department_id,
            floor_id,
            mailAddress,
            firstNameCc,
            lastNameCc,
            firstNameKana,
            lastNameKana,
            password,
            oldPassword,
            newPassword,
            downloadflag,
            permission_id,
            csvFile,
            user_affiliation_flag,
            isSetShowAddingConfirmationPopup,
            confirmMemo
        } = this.state

        // CSV登録の場合は、追加確認ポップアップ表示前にCSVファイルの判定を実行
        if (modalType === 'csvInsert') {
            this.blockUI();
            let result = await this.getCsvData(csvFile);
            let insertRow = result.insertArray;
            let errData = result.errorData;
            let errMessage = [];

            if (errData && errData.length > 0) {
                errMessage.push(this.props.langText.Message[errData[0]]);
                // エラーがある場合のメッセージ作成処理
                switch (errData[0]) {
                    case "CsvTooManyRows":
                        errMessage[0] = this.sprintf(
                            this.props.langText.Message.CsvTooManyRows,
                            this.props.systemParameters.USER_CSV_ROW_COUNT_MAX_LIMIT
                        );
                        break;
                    case "CsvHeaderError":
                        // ヘッダーエラー
                        break;
                    case "CsvNotAvailable":
                        // バリデーションエラー
                        errMessage.push(
                            this.sprintf(
                                this.props.langText.Message.FailedDataCount,
                                errData[1].length
                            )
                        );
                        errData[1].forEach((err) => {
                            errMessage.push(
                                this.sprintf(this.props.langText.Message.Line, err.row + 2) +
                                    "　" +
                                    err.message
                            );
                        });
                        break;
                    default:
                        throw new Error("ProcessingFailedError");
                        break;
                }
                this.setState({
                    errorMessageModalShow: true,
                    errText: errMessage.join("\r\n"),
                    csvInsertLoadingFlag: false,
                    loadingDisplayFlag: false
                });
                this.unblockUI();
                this.reactTableRefresh();
                return;
            } else {
                // CSVデータが正常な場合、stateに保存して後で使用
                this.setState({ csvInsertData: insertRow });
                
                if(this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
                    // CSV解析成功後、ポップアップオプションをチェック
                    await this.checkCsvPopupOptions(insertRow);
                    
                }
                this.unblockUI();
            }
        }

        // 確認メッセージ用のキーアイテムを事前に取得
        const confirmKeyItem = await this.getConfirmKeyItem(modalType);

        // confirmKeyItemをstateに保存
        this.setState({ confirmKeyItem: confirmKeyItem });

                // 追加確認ポップアップの表示条件チェック
        let shouldShowAddingConfirmationPopup = false;

        if (modalType === 'csvInsert' && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            // CSV登録の場合：user_affiliation_flagに応じて判定
            if (this.state.csvPopupOptions) {
                if (this.state.user_affiliation_flag) {
                    // 会社選択オプションがON：選択した会社のポップアップオプション
                    if (this.state.csvPopupOptions.general && this.state.csvPopupOptions.general.showPopup) {
                        shouldShowAddingConfirmationPopup = true;
                    }
                } else {
                    // 会社選択オプションがOFF：CSV内会社情報でのポップアップオプション
                    if (this.state.csvPopupOptions.special && this.state.csvPopupOptions.special.hasAnyPopupOption) {
                        shouldShowAddingConfirmationPopup = true;

                    }
                }
            }
        } else {
            // 通常の登録・更新・削除の場合
            shouldShowAddingConfirmationPopup = 
                this.isTargetShowAddingConfirmationPopup &&
                isSetShowAddingConfirmationPopup;
        }

        if (shouldShowAddingConfirmationPopup) {
            // 追加確認ポップアップを表示すべき場合
            if (!this.state.showConfirm) {
                // 初回ボタン押下時：追加確認ポップアップを表示
                this.onClickConfirm(event, true);
                return;
            }
        } else {
            // 追加確認ポップアップ表示設定がOFFである場合、
            // 通常の確認ポップアップを表示
            let popupItem = confirmKeyItem;
            if (modalType === 'csvInsert') {
                popupItem = this.state.csvInsertData.length;
            }
            if (!window.confirm(`${this.createPopupMessage(
                this.props.langText.Body.User,
                popupItem,
                modalType
            )}`)) {
                return;
            }
        }

        switch (modalType) {
            case 'copy':
            case 'insert':
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/insert`, {
                        mailAddress,
                        firstNameCc,
                        lastNameCc,
                        firstNameKana,
                        lastNameKana,
                        password,
                        company_id,
                        permission_id,
                        department_id: floor_id || department_id,
                        downloadflag,
                        confirmMemo,
                        isSetShowAddingConfirmationPopup
                    })
                    .then(result => {
                        alert(
                            `${result.data.mailAddress} ${this.props.langText.Message.User_DataInsertSuccess}`
                        )
                        this.reactTableRefresh()
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    })
                    .catch(err => {
                        alert(
                            this.getErrorString(err.response?.data || err)
                        );
                        if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: "",
                                confirmValue: ""
                            });
                        }
                    })
                break

            case 'update':
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/update`, {
                        userId,
                        mailAddress,
                        firstNameCc,
                        lastNameCc,
                        firstNameKana,
                        lastNameKana,
                        oldPassword,
                        newPassword,
                        company_id,
                        department_id: floor_id || department_id,
                        downloadflag,
                        permission_id,
                        confirmMemo,
                        isSetShowAddingConfirmationPopup
                    })
                    .then(result => {
                        alert(
                            this.props.langText.Message.DataUpdateSuccess
                        )
                        this.reactTableRefresh()
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    })
                    .catch(err => {
                        alert(
                            this.getErrorString(err.response?.data || err)
                        );
                        if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: "",
                                confirmValue: ""
                            });
                        }
                    })
                break

            case 'delete':
                // 追加確認ポップアップが表示されない場合は、既にconfirm処理が完了している
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/delete`, {
                        userId,
                        mailAddress,
                        company_id,
                        firstNameCc,
                        lastNameCc,
                        permission_id,
                        department_id: floor_id || department_id,
                        confirmMemo,
                        isSetShowAddingConfirmationPopup
                    })
                    .then(result => {
                        alert(
                            this.props.langText.Message.DataDeleteSuccess
                        )
                        this.reactTableRefresh()
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        });
                    })
                    .catch(err => {
                        alert(
                            this.getErrorString(err.response?.data || err)
                        );
                        if (err.response?.data?.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: "",
                                confirmValue: ""
                            });
                        }
                    })
                break

            case "csvInsert":
                this.blockUI();

                // DBとCognitoへの登録処理
                let result = await this.ascAxios("post", `${this.reactContainerPath}/csvInsert`, {
                    company_id,
                    permission_id,
                    department_id: floor_id || department_id,
                    insertRow: this.state.csvInsertData,
                    user_affiliation_flag,
                    confirmMemo,
                    isSetShowAddingConfirmationPopup: this.state.requiresPopup || shouldShowAddingConfirmationPopup
                });
                if (result.data.cognitoErrMailAddress.length === 0) {
                    // エラーが1件もない場合、全メールアドレス登録成功メッセージを表示
                    alert(this.sprintf(
                        this.props.langText.Message.CsvRegisterSuccess,
                        this.props.langText.Body.User, 
                        this.state.csvInsertData.length));
                } else {
                    // Cognitoへの登録が失敗したメールアドレスをメッセージで表示
                    let userCsvRegisterErrorMsg = this.sprintf(
                        this.props.langText.Message.CsvRegisterError,
                        this.state.csvInsertData.length,
                        result.data.cognitoErrMailAddress.length,
                        this.props.langText.Body.User, 
                    );
                    for ( let errId of result.data.cognitoErrMailAddress ) {
                        userCsvRegisterErrorMsg += "\r\n" + "・" + errId;
                    }
                    alert( userCsvRegisterErrorMsg );
                }
                this.reactTableRefresh();
                this.setState({ 
                    show: false,
                    showConfirm: false,
                    confirmMemo: "",
                    confirmValue: ""
                });
                break;

            default:
                alert(
                    this.getErrorString({code: 'modal'})
                );
                this.setState({
                    show: false,
                    showConfirm: false,
                    confirmMemo: "",
                    confirmValue: ""
                });
                break;
        }
    }

    onClickCancelLockingBtn = (userId) => async event => {
        try{
            await this.ascAxios('post', `${this.reactContainerPath}/userLockingCancel`, {
                userId
            })
            alert(this.props.langText.Message.User_CancelUserLockingSuccess);
            this.reactTableRefresh();
        } catch(err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }

        this.setState({show: false});
    }

    onSelectChange (event, param) {
        super.onSelectChange(event, param);
        let value = (event && event.value) ? event.value : "";
        let department_prefix = (event && event.department_prefix) ? event.department_prefix : "";
        let floor_flg = (event && event.floor_flg) ? event.floor_flg === "Y" : "";
        let permission_json_data = (event && event.json_data) ? event.json_data : "";

        if (param === "company_id") {
            // 会社選択時に追加確認ポップアップ設定を取得
            let additionalState = {};
            if (value) {
                this.getIsShowAddingConfirmationPopup(value).then((result) => {
                    this.setState({isSetShowAddingConfirmationPopup: result});
                }).catch(error => {
                    console.error(error);
                    this.setState({isSetShowAddingConfirmationPopup: false});
                });
            } else {
                additionalState.isSetShowAddingConfirmationPopup = false;
            }

            this.setState({
                department_id: '',
                floor_id: '',
                permission_id: '',
                permission_json_data: "",
                floor_flg: floor_flg,
                additionalState
            });
            this.getDepartmentSelect({company_id: value, floor_flg: floor_flg});
            this.getFloorSelect({
                company_id: this.state.company_id,
                department_id: value,
                floor_flg: this.state.floor_flg,
                department_prefix: department_prefix
            });
            this.setPermissionSelect(value, floor_flg);
        } else if (param === "department_id") {
            this.floor_load_flag = true;
            this.setState({floor_id: ''});
            this.getFloorSelect({
                company_id: this.state.company_id,
                department_id: value,
                department_prefix: department_prefix,
                floor_flg: this.state.floor_flg,
            });
        } else if (param === "permission_id") {
            this.setState({
                permission_id: value,
                permission_json_data: permission_json_data
            });
        } else if (param === "csvExportCompanyId") {
            this.setState({
                csvExportDepartmentId: [],
                csvExportFloorId: [],
                floor_flg,
                csvExportValidationMessage: []
            });
            this.setCommonDepartmentSelect(value, floor_flg);
        }
    }

    onCheckBoxChange(event, param){
        super.onCheckBoxChange(event, param);

        if (param === "user_affiliation_flag") {
            let initIds = {};
            if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
                initIds = {
                    department_id: '',
                    floor_id: ''
                }
                
            } else {
                initIds = {
                    company_id: '',
                    department_id: '',
                    floor_id: ''
                }
            }
            this.setState({...initIds, headerJson: this.moldCsvHeader(event.currentTarget.checked)});
            this.removeCsvFile();
            // CSVファイルを削除する
            this.csvReaderRef.current.removeFile();
        }
    }

    getCompanySelect = () => {
        this
            .ascAxios('post', `Common/companySelect`, {container: this.reactContainerPath})
            .then(res => {
                this.common_buttondisabledLengthCheck(`company_id`,`push`);
                this.setState({
                    companySelect: res.data
                })
            })
            .catch(err => {
                alert(
                    this.getErrorString(err.response.data)
                )
            })
    }

    getDepartmentSelect = ({company_id, floor_flg, department_id, department_prefix}, type) => {
        if(company_id)
        {
            this.common_buttondisabledLengthCheck(`department_load`,`push`);
        }
        else
        {
            this.common_buttondisabledLengthCheck(`department_load`,`pop`);
        }
        this
            .ascAxios('post', `Common/departmentSelect`, {container: this.reactContainerPath, company_id, floor_flg})
            .then(res => {
                if (type === "update" && floor_flg && department_id && department_prefix) {
                    let my_prefix = department_prefix.slice(0, 2);
                    res.data.forEach(row => {
                        if (row.department_prefix && my_prefix === row.department_prefix) {
                            this.setState({department_id: row.value});
                        }
                    });
                }

                if(company_id)
                {
                    this.common_buttondisabledLengthCheck(`department_id`,`push`);
                    this.common_buttondisabledLengthCheck(`department_load`,`pop`);
                }
                else
                {
                    this.common_buttondisabledLengthCheck(`department_id`,`pop`);
                }

                this.setState({
                    departmentSelect: res.data
                })
            })
            .catch(err => {
                alert(
                    this.getErrorString(err.response.data)
                )
            })
    }

    setCommonDepartmentSelect = async (company_id, floor_flg) => {
        try {
            let departmentList = await this.ascAxios("post", `Common/departmentSelect`, {
                container: this.reactContainerPath,
                company_id,
                floor_flg
            });
            this.setState({
                csvExportDepartmentId: departmentList.data || [],
                csvExportDepartmentSelect: departmentList.data || []
            });
            const departmentId = departmentList.data.map(row => {return row.value});
            this.setCommonFloorSelect(departmentId);
        } catch (err) {
            this.showErrorObjectMesssage(err);
        }
    }

    /**
     * 権限一覧取得
     * @param company_id
     * @param floor_flg
     */
    async setPermissionSelect(company_id = null, floor_flg) {

        try {
            let result = await this.ascAxios('post', `Common/getPermissions`, {
                container: this.reactContainerPath,
                company_id: company_id,
                floor_flg: floor_flg
            })
            this.setState({
                permissionSelect: result.data,
                permissionSelectLoad: false
            })
        } catch (err) {
            alert(this.getErrorString(err.response.data))
            return null;
        }
    }

    getFloorSelect = ({company_id, department_id, department_prefix, floor_flg}) => {
        if(this.floor_load_flag === true && department_id && company_id)
        {
            this.common_buttondisabledLengthCheck(`floor_load`,`push`);
        }
        else
        {
            this.common_buttondisabledLengthCheck(`floor_load`,`pop`);
        }
        if (floor_flg) {
            this.ascAxios('post', `Common/floorSelect`, {container: this.reactContainerPath, company_id, department_prefix})
            .then(res => {
                if(this.state.department_id)
                {
                    this.common_buttondisabledLengthCheck(`floor_id`,`push`);
                    this.common_buttondisabledLengthCheck(`floor_load`,`pop`);
                    this.floor_load_flag = false;
                }
                else
                {
                    this.common_buttondisabledLengthCheck(`floor_id`,`pop`);
                }
                this.setState({
                    floorSelect: res.data
                })
            })
            .catch(err => {
                alert(this.getErrorString(err.response.data))
            })
        }
    }

    setCommonFloorSelect = async (departmentIds) => {
        try {
            let floorList = await this.ascAxios("post", `Common/getFloorsByDepartmentIds`, {
                container: this.reactContainerPath,
                departmentIds
            });
            this.setState({
                csvExportFloorId: floorList.data || [],
                csvExportFloorSelect: floorList.data || [],
            });
        } catch (err) {
            this.showErrorObjectMesssage(err);
        }
    };

    onRadioChangebool = (event,param,booltype) => {
        if(booltype === true)
        {
            this.setState({[param]: 'Y'});
        }
        else
        {
            this.setState({[param]: 'N'});
        }
    }

    onMultiSelectChange = async (event, param) => {
        if (param === "csvExportDepartmentId") {
            let value_arr = (event.length > 0) ? [] : "";

            event.forEach((row, key) => {
                value_arr[key] = row['value'];
            });
            await this.setCommonFloorSelect(value_arr);
        }

        this.setState({[param]: event});
        await this.getCsvSelectValidationCheck(event, param);
    }

    getCsvSelectValidationCheck = (event, param) => {
        let {
            csvExportFloorId,
            floorSelect,
            csvExportValidationMessage
        } = this.state;

        let message = [];

        const departmentNotSelected = this.sprintf(this.props.langText.Message.NoSelected, this.props.langText.Body.Department);
        const floorNotSelected = this.sprintf(this.props.langText.Message.NoSelected, this.props.langText.Body.Floor);

        switch (param) {
            case 'csvExportDepartmentId':
                //拠点が選択されてない場合、拠点エラーメッセージ表示
                if (event.length === 0) {
                    message.push(departmentNotSelected);
                //拠点が1個以上選択されている場合、拠点エラーメッセージ非表示
                } else if (event.length > 0) {
                    message = csvExportValidationMessage.filter(row => row !== departmentNotSelected);
                    //フロア無しの会社である場合、もしくはフロア有りの会社かつフロアが1個以上選択されている場合、フロアエラーメッセージ非表示
                    if (floorSelect.length === 0 || (floorSelect.length > 0 && csvExportFloorId.length > 0)) {
                        message = message.filter(row => row !== floorNotSelected);
                    }
                }
                break;
            case 'csvExportFloorId':
                //フロアが選択されてない場合、フロアエラーメッセージ表示
                if (event.length === 0) {
                    message.push(floorNotSelected);
                //フロアが1個以上選択されている場合、フロアエラーメッセージ非表示
                } else if (event.length > 0) {
                    message = csvExportValidationMessage.filter(row => row !== floorNotSelected);
                }
                break;
            default:
                break;
        }
        const set = new Set(message);
        this.setState({
            csvExportValidationMessage : [...set]
        });
    }

    validationHandle = param => {
        let validation_flag = true;

        let {
            mailAddress,
            firstNameCc,
            lastNameCc,
            company_id,
            department_id,
            floor_id,
            floor_flg,
            permission_id,
            permission_json_data,
            csvFile,
            csvInsertLoadingFlag
        } = this.state

        let emailCheck = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/

        let adminFlag = false;

        switch (param) {
            case 'mailAddress':
                validation_flag = emailCheck.test(this.state[param]);
                break;
            case 'firstNameCc':
            case 'lastNameCc':
                validation_flag = !!this.state[param];
                break;

            case 'company_id':
                validation_flag = !!this.state[param]
                break;

            case 'department_id':
            case 'floor_id':
                if (permission_json_data) {
                    let allScopeCode = permission_json_data.map(row => {
                        return row.scope_code
                    })
                    adminFlag = allScopeCode.every(row => {
                        return row === GlobalConst.SCOPE_OBJECT.oem.name || row === GlobalConst.SCOPE_OBJECT.system.name
                    })
                }
                validation_flag = !!this.state[param] || adminFlag;
                break;
            case 'permission_id':
                validation_flag = !!this.state[param]
                break;

            case 'copy':
            case 'insert':
                if (permission_json_data) {
                    let allScopeCode = permission_json_data.map(row => {
                        return row.scope_code
                    })
                    adminFlag = allScopeCode.every(row => {
                        return row === GlobalConst.SCOPE_OBJECT.oem.name || row === GlobalConst.SCOPE_OBJECT.system.name
                    })
                }
                validation_flag = (
                    emailCheck.test(mailAddress)
                    && firstNameCc
                    && lastNameCc
                    && this.passwordValidationHandle(param, this.state)
                    && (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)
                        || (company_id !== null && company_id !== ''))
                    && (adminFlag || (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.department)
                        || (department_id !== null && department_id !== '')))
                    && (adminFlag || !floor_flg
                        || (floor_flg && (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.floor)
                            || (floor_id !== null && floor_id !== ''))))
                    && permission_id
                )
                break;

            case 'update':
                if (permission_json_data) {
                    let allScopeCode = permission_json_data.map(row => {
                        return row.scope_code
                    })
                    adminFlag = allScopeCode.every(row => {
                        return row === GlobalConst.SCOPE_OBJECT.oem.name || row === GlobalConst.SCOPE_OBJECT.system.name
                    })
                }
                validation_flag = (
                    firstNameCc
                    && lastNameCc
                    && (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)
                        || (company_id    !== null && company_id    !== ''))
                    && (adminFlag || (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.department)
                        || (department_id !== null && department_id !== '')))
                    && (adminFlag || !floor_flg
                        || (floor_flg && (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.floor)
                            || (floor_id !== null && floor_id !== ''))))
                    && permission_id
                    && this.passwordValidationHandle(param, this.state)
                );
                break;

            case 'delete':
                validation_flag = (
                    firstNameCc
                    && lastNameCc
                    && (company_id !== null && company_id !== '')
                    && (department_id !== null && department_id !== '')
                    && !floor_flg || (floor_flg && (floor_id !== null && floor_id !== ''))
                    && permission_id
                )
                break;
        
            case "csvInsert":
                if (this.state.user_affiliation_flag) {
                    validation_flag =
                        (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company) ||
                            (company_id !== null && company_id !== "")) &&
                        (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.department) ||
                            (department_id !== null && department_id !== "")) &&
                        (!floor_flg ||
                            (((floor_flg &&
                                this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.floor)) ||
                                (floor_flg !== null && floor_flg !== "")))) &&
                                csvFile && !csvInsertLoadingFlag
                }else{
                    validation_flag = csvFile && !csvInsertLoadingFlag
                }
                break;

            default:
                validation_flag = true;
                break;
        }
        return validation_flag;
    }

    /**
     * modalTypeにより分岐させる
     */
    getModalBranch = () => {
        switch (this.state.modalType) {
            case "insert":
            case "update":
            case "copy":
            case "delete":
            case "read":
                return (
                    <UserModal
                        getErrorString = {this.getErrorString}
                        getScopeGreaterEqual = {this.getScopeGreaterEqual}
                        currentPermission = {this.props.currentPermission}
                        floor_flg = {this.state.floor_flg}
                        loginUserId = {this.props.userInfo.user_id}
                        state = {this.state}
                        propSetState = {this.propSetState}
                        langText = {this.props.langText}
                        charaLimit = {this.props.charaLimit}
                        onClick = {this.onClickHandle}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        onSelectChange = {this.onSelectChange}
                        onMultiSelectChange = {this.onMultiSelectChange}
                        onCheckBoxChange = {this.onCheckBoxChange}
                        onRadioChange = {this.onRadioChange}
                        onRadioChangebool = {this.onRadioChangebool}
                        validationHandle = {this.validationHandle}
                        onClickCancelLockingBtn = {this.onClickCancelLockingBtn}
                        passwordValidationHandle = {this.passwordValidationHandle}
                    />
                );
            case "csvInsert":
                return (
                    <UserCsvInsertModal
                        floor_flg={this.state.floor_flg}
                        getScopeGreaterEqual={this.getScopeGreaterEqual}
                        getScopeLessThanEqual={this.getScopeLessThanEqual}
                        state={this.state}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        onSelectChange={this.onSelectChange}
                        onClick={this.onClickHandle}
                        onCheckBoxChange = {this.onCheckBoxChange}
                        handleOnDrop={this.handleOnDrop}
                        validationHandle={this.validationHandle}
                        charaLimit={this.props.charaLimit}
                        sprintf={this.sprintf}
                        getSelectOption={this.getSelectOption}
                        removeCsvFile={this.removeCsvFile}
                        csvReaderRef={this.csvReaderRef}
                        csvRowCountMaxLimit={this.props.systemParameters.USER_CSV_ROW_COUNT_MAX_LIMIT}/> 
                );
            default:
                break;
        }
    };

    /**
     * CSVファイルをアップロードまたはドラッグした際の読み込み処理
     * @param {} data
     * @param {} file
     */
    handleOnDrop = (data, file) => {
        let jsonData = data;

        // ファイル名チェック
        if (!file.name.match(/.csv$/i)) {
            alert(this.props.langText.Message.NotCsvFile);
            this.setState({ csvFile: false });
        } else {
            this.setState({ csvFile: jsonData });
        }
    };

    /**
     * アップロード済みのCSVファイルの削除処理
     */
    removeCsvFile = () => {
        this.setState({ csvFile: false });
    };

    /**
     * CSV登録時のポップアップオプションチェック
     * @param {Array} insertRow - CSV解析後のデータ配列
     */
    checkCsvPopupOptions = async (insertRow) => {
        try {
            
            
            let requestData = {};
            
            if (this.state.user_affiliation_flag) {
                // 会社選択オプションがON（true）の場合：選択した会社のオプションを取得

                requestData.company_id = this.state.company_id;
            } else {
                // 会社選択オプションがOFF（false）の場合：CSV内容の会社のオプションを取得
                const csvCompanyList = [];
                const companyIdSet = new Set();
                
                insertRow.forEach(row => {
                    if (row.companyName && !companyIdSet.has(row.companyName)) {
                        companyIdSet.add(row.companyName);
                        csvCompanyList.push(row.companyName);
                    }
                });
                requestData.csvCompanyList = csvCompanyList;
            }
            
            const result = await this.ascAxios('post', `${this.reactContainerPath}/getPopupOptionForCsv`, requestData);
            
            // 結果をstateに保存
            let requiresPopup = false;
            
            if (this.state.user_affiliation_flag) {
                // 会社選択オプションがONの場合：一般ケースのチェック
                if (result.data.general && result.data.general.showPopup) {
                    requiresPopup = true;
                }
            } else {
                // 会社選択オプションがOFFの場合：特殊ケースのチェック
                if (result.data.special && result.data.special.hasAnyPopupOption) {
                    requiresPopup = true;
                }
            }
            
            this.setState({
                csvPopupOptions: result.data,
                requiresPopup: requiresPopup,
                isSetShowAddingConfirmationPopup: requiresPopup
            });
            

            
        } catch (error) {
            console.error('[User] checkCsvPopupOptions エラー:', error);
            // エラーが発生した場合はポップアップを表示しない
            this.setState({
                csvPopupOptions: null,
                requiresPopup: false,
                isSetShowAddingConfirmationPopup: false
            });
        }
    };

    /**
     * CSVデータをjsonカラムへ変換
     * @param {file} importFile
     * @return {array}
     *  insertArray DB(cm15)・cognitoへ登録する情報
     *  errorData [0]:エラーコード, [1]:エラー内容 errorDataに1件以上データがある場合、CSV登録は行われない
     */
    async getCsvData(importFile) {
        try {
            let insertArray = [];
            let errorData = [];
            let errorValidateUserCsv = [];

            if(importFile.slice(-1)[0].data.length === 1 && importFile.slice(-1)[0].data[0] === ""){
                // 最終行に改行が入っている場合、消去
                importFile.pop();
            }

            const csvHeaders = importFile[0].data.map((header) => header.trim());
            const list = importFile.filter((row, index) => {
                if (index !== 0) return row.data;
            });

            // CSV件数チェック
            if (list.length > this.props.systemParameters.USER_CSV_ROW_COUNT_MAX_LIMIT) {
                errorData[0] = "CsvTooManyRows";
                return { errorData };
            }

            // ヘッダ数チェック
            if (csvHeaders.length !== this.state.headerJson.length) {
                errorData[0] = "CsvHeaderError";
                return { errorData };
            }

            // ヘッダ設定値チェック
            csvHeaders.forEach((row, index) => {
                if (row !== this.state.headerJson[index].label) {
                    errorData[0] = "CsvHeaderError";
                    return { errorData };
                }
            });

            // メールアドレスの既存重複チェック用データ取得・作成
            const allMailAddress = await this.ascAxios(
                                        "post",
                                        "/User/getAllMailAddress"
                                    );
            const checkMailAddress = allMailAddress.data.map((row) => row.mail_address);

            // 権限の既存登録有無チェック用データ取得・作成
            const checkPermission = this.state.permissionSelect.map((row) => row.label);

            // メールアドレスのCSV内重複チェック用配列
            const csvUserMailAddressList = [];

            // メールアドレスのチェック(メールアドレス形式)
            const mailAddressCheck = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-Za-z0-9\-]+/;
            // パスワードのチェック(小文字の英数字が1文字以上必要・全角禁止・8文字以上)
            const passwordCheck = /^(?=.*?[a-z])(?=.*?[0-9])[\x20-\x7e]{8,}$/;

            // 1度チェックしたデータを毎回チェックしなくていいように以前の会社・拠点・フロアとしてそれぞれ保管する（負荷軽減）
            let previousCompany = [];
            let previousDepartment = [];
            let previousFloor = [];

            // CSVデータ部を1行ずつループ
            for (let [rowIndex, detailRow] of list.entries()) {
                
                let detail = {};
                let tmpDetail = detailRow.data;
                let checkBlankFlag = false;      //空白フラグ
                let previousCompanyIndex = null;
                let previousDepartmentIndex = null;

                //すべての項目が空白の場合はスキップする
                if (!tmpDetail.find(item => item.replace(/ /g,"").length > 0)) {
                    continue;
                }

                // CSV内重複チェックのため、配列に追加
                csvUserMailAddressList.push(tmpDetail[0]);

                // データ部のカラム数チェック
                if (tmpDetail.length !== this.state.headerJson.length) {
                    errorValidateUserCsv.push({
                        row: rowIndex,
                        message: this.sprintf(
                            this.props.langText.Message["CsvDataCountError"],
                            this.state.headerJson.length
                        )
                    });
                    break;
                }

                // 1カラムずつバリデーションチェックを行う。
                // エラーがあればエラー情報配列に行数、エラー内容をpush
                for (let [columnIndex, item] of tmpDetail.entries()) {
                    let value = "";
                    let errorFlg = false;
                    const jsonKey = this.state.headerJson[columnIndex].key;
                    const jsonLabel = this.state.headerJson[columnIndex].label;

                    // 全項目文字数チェック
                    if ([...item].length > this.props.charaLimit[`User_${jsonKey}`]) {
                        errorValidateUserCsv.push({
                            row: rowIndex,
                            message: this.sprintf(
                                this.props.langText.Message["CsvSizeError"],
                                jsonLabel,
                                this.props.charaLimit[`User_${jsonKey}`]
                            )
                        });
                    }

                    // 必須入力項目チェック
                    let requiredFieldArr = this.state.headerJson.filter(row => row.required && row.required === true);

                    if (requiredFieldArr.find(row => row.key === jsonKey) &&
                        (item === "" || item === undefined || item.length === 0)) {
                            errorValidateUserCsv.push({
                                row: rowIndex,
                                message: this.sprintf(
                                    this.props.langText.Message["CsvRequiredError"],
                                    jsonLabel
                                )
                            }
                        );
                    }

                    switch (jsonKey) {
                        case "companyName":
                            // 会社名の項目が空白であれば処理を終了する
                            if (item.length === 0) {
                                checkBlankFlag = true;
                                break;
                            }
                            // 以前に確認した会社名かどうかを確認して、あればインデックスを保管する
                            previousCompanyIndex = previousCompany.findIndex(row => row.name === item)
                            // 以前に確認した会社名でない場合
                            if (previousCompanyIndex === -1) {
                                // 会社名の登録チェック用データをサーバー側より取得する
                                const checkRegisteredCompany = await this.ascAxios("post",`${this.reactContainerPath}/checkRegisteredCompany`, {companyName: item});
                                // チェックした会社データを保管する
                                previousCompany.push({
                                    name: item,
                                    id: checkRegisteredCompany.data && checkRegisteredCompany.data.id ? checkRegisteredCompany.data.id : null
                                })
                                // 上で追加したデータのインデックスに更新する
                                previousCompanyIndex = previousCompany.length - 1
                                // 会社IDをデータ取得できなかったときはエラーにする
                                if(!previousCompany[previousCompanyIndex].id){
                                    errorValidateUserCsv.push({
                                        row: rowIndex,
                                        message: this.sprintf(
                                            this.props.langText.Message["CsvNotRegisteredInfoError"],
                                            jsonLabel,
                                            item
                                        )
                                    });
                                    errorFlg = true;
                                }
                            }
                            if (errorFlg) {
                                break;
                            }
                            //　以前に確認した会社データのID、または今回取得したIDを入れる
                            value = previousCompany[previousCompanyIndex].id;
                            break;

                        case "departmentName":
                            // 拠点名の項目が空白である、または会社管理者以上かつ空白フラグがtrueであれば処理を終了する
                            if (item.length === 0 || (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company) && checkBlankFlag)) {
                                checkBlankFlag = true;
                                break;
                            }
                            // 以前に確認した拠点名かどうかを確認して、あればインデックスを保管する
                            previousDepartmentIndex = previousDepartment.findIndex(row => row.name === item)
                            // 以前に確認した拠点名でない場合
                            if (previousDepartmentIndex === -1) {
                                // 会社名は入力値またはユーザー情報より取得する
                                let companyId = previousCompanyIndex !== null ? previousCompany[previousCompanyIndex].id : this.props.userInfo.company_id
                                // 拠点名の登録チェック用データをサーバー側より取得する
                                const checkRegisteredDepartment = 
                                    await this.ascAxios("post",`${this.reactContainerPath}/checkRegisteredDepartment`,
                                    {companyId: companyId, departmentName: item});
                                // チェックした拠点データを保管する
                                previousDepartment.push({
                                    name: item,
                                    id: checkRegisteredDepartment.data && checkRegisteredDepartment.data.id ? checkRegisteredDepartment.data.id : null,
                                    prefix: checkRegisteredDepartment.data && checkRegisteredDepartment.data.department_prefix ? checkRegisteredDepartment.data.department_prefix : null
                                })
                                // 上で追加したデータのインデックスに更新する
                                previousDepartmentIndex = previousDepartment.length - 1
                                // 拠点IDをデータ取得できなかったときはエラーにする
                                if(!previousDepartment[previousDepartmentIndex].id){
                                    errorValidateUserCsv.push({
                                        row: rowIndex,
                                        message: this.sprintf(
                                            this.props.langText.Message["CsvNotRegisteredInfoError"],
                                            jsonLabel,
                                            item
                                        )
                                    });
                                    errorFlg = true;
                                }
                            }
                            if (errorFlg) {
                                break;
                            }
                            // 以前に確認した拠点データのID、または今回取得したIDを入れる
                            value = previousDepartment[previousDepartmentIndex].id;
                            break;

                        case "floorName":
                            // フロア名の項目が空白である、または拠点管理者以上かつ空白フラグがtrueであれば処理を終了する
                            if (item.length === 0 || (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department) && checkBlankFlag)) {
                                break;
                            }
                            // 以前に確認したフロア名かどうかを確認する
                            let checkedPreviousFloor = previousFloor.find(row => row.name === item)
                            // 以前に確認したフロア名でない場合
                            if (!checkedPreviousFloor) { 
                                // 会社名と拠点のプレフィックスは入力値またはユーザー情報より取得する
                                let companyId = previousCompanyIndex !== null ? previousCompany[previousCompanyIndex].id : this.props.userInfo.company_id
                                let departmentPrefix = previousDepartmentIndex !== null ? previousDepartment[previousDepartmentIndex].prefix : this.props.userInfo.department_prefix.slice(0, 2)
                                const checkRegisteredFloor = 
                                    await this.ascAxios("post",`${this.reactContainerPath}/checkRegisteredFloor`,
                                    {companyId: companyId, departmentPrefix: departmentPrefix, floorName: item});
                                // チェックしたフロアデータを保管する
                                previousFloor.push({
                                    name: item,
                                    id: checkRegisteredFloor.data && checkRegisteredFloor.data.id ? checkRegisteredFloor.data.id : null,
                                    prefix: checkRegisteredFloor.data && checkRegisteredFloor.data.department_prefix ? checkRegisteredFloor.data.department_prefix : null
                                })
                                // フロアIDをデータ取得できなかったときはエラーにする
                                if (!previousFloor[previousFloor.length - 1].id) {
                                    errorValidateUserCsv.push({
                                        row: rowIndex,
                                        message: this.sprintf(
                                            this.props.langText.Message["CsvNotRegisteredInfoError"],
                                            jsonLabel,
                                            item
                                        )
                                    });
                                    errorFlg = true;
                                }
                            }
                            if (errorFlg) {
                                break;
                            }
                            // 以前に確認したフロアデータがあればそのIDを、なければ今回取得したIDを入れる
                            value = checkedPreviousFloor ? checkedPreviousFloor.id : previousFloor[previousFloor.length - 1].id;
                            break;

                        case "mailAddress":
                            // メールアドレスのフォーマットチェック
                            if (!mailAddressCheck.test(item) && item.length !== 0) {
                                errorValidateUserCsv.push({
                                    row: rowIndex,
                                    message: this.sprintf(
                                        this.props.langText.Message["CsvFormatError"],
                                        jsonLabel
                                    )
                                });
                                errorFlg = true;
                            }
                            // メールアドレスの重複チェック(既存)
                            if (checkMailAddress.indexOf(item) >= 0) {
                                errorValidateUserCsv.push({
                                    row: rowIndex,
                                    message: this.sprintf(
                                        this.props.langText.Message["CsvDuplicateErrorInDb"],
                                        jsonLabel,
                                        item
                                    )
                                });
                                errorFlg = true;
                            }
                            // CSV内のメールアドレス重複チェック
                            let countIdInCsv = csvUserMailAddressList.filter((id) => id === item).length;
                            if (countIdInCsv > 1) {
                                errorValidateUserCsv.push({
                                    row: rowIndex,
                                    message: this.sprintf(
                                        this.props.langText.Message["CsvDuplicateErrorInCsv"],
                                        jsonLabel,
                                        item
                                    )
                                });
                                errorFlg = true;
                            }
                            if (errorFlg) {
                                break;
                            }
                            value = item;
                            break;
                        case "password":
                            // パスワードのフォーマットチェック
                            if (!passwordCheck.test(item) && item.length !== 0) {
                                errorValidateUserCsv.push({
                                    row: rowIndex,
                                    message: this.sprintf(
                                        this.props.langText.Message["CsvFormatError"],
                                        jsonLabel
                                    )
                                });
                                errorFlg = true;
                            }
                            if (errorFlg) {
                                break;
                            }
                            value = item;
                            break;
                        case "permission":
                            // 権限の登録有無チェック
                            if (checkPermission.indexOf(item) === -1 && item.length !== 0) {
                                errorValidateUserCsv.push({
                                    row: rowIndex,
                                    message: this.sprintf(
                                        this.props.langText.Message["CsvNotRegisteredInfoError"],
                                        jsonLabel,
                                        item
                                    )
                                });
                                errorFlg = true;
                            }
                            if (errorFlg || item.length === 0) {
                                break;
                            }
                            value = this.state.permissionSelect.find(row => row.label === item).value;
                            break;
                        default:
                            value = item;
                            break;
                    }
                    detail[this.state.headerJson[columnIndex].key] = value;
                }

                insertArray.push(detail);
            }


            if (errorValidateUserCsv.length > 0) {
                errorData[0] = "CsvNotAvailable";
                errorData[1] = errorValidateUserCsv;
            }
            return { insertArray, errorData };
        } catch (err) {
            console.error(err);
            throw new Error(err);
        }
    }

    // 出力するCSVのファイル名を「(会社名)_ユーザー情報リスト_(出力時間)」に設定
    getCsvFileName() {

        // 会社名の設定
        // OEM管理者権限以上であれば画面で選択した会社名、そうでなければログインユーザーが所属する会社名を設定
        const company_name =
            this.state.csvExportCompanyId
            && this.state.companySelect.length > 0
            && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)
                ? this.state.companySelect.find(row => row.value === this.state.csvExportCompanyId).label
                : this.props.userInfo.company_name
        ;
        const now_time = moment().utc().add(9, "h").format("YYYYMMDDHHmmss");
        const file_name =
            company_name
            + "_"
            + this.props.langText.Body.UserCsvExportList
            + "_"
            + now_time
            + ".csv"
        ;

        return file_name;
    }

    /**
     * エラーモーダル（CSV投入処理）のクローズ処理
     */
    errorModalClose = () => {
        this.setState({ errorMessageModalShow: false });
    };

    // CSV登録時の詳細確認メッセージを作成
    getCsvItems = () => {
        const { csvFile, csvInsertData, user_affiliation_flag } = this.state;

        let csvItems = [];
        const displayLimit = 5; // 最大5件まで表示
        const totalCount = csvInsertData.length;
        
        // ヘッダーを追加
        csvItems.push(["Email", "ユーザー名"]);

        // headerJsonからインデックスを取得
        const mailAddressIndex = this.state.headerJson.findIndex(header => header.key === "mailAddress");
        const firstNameCcIndex = this.state.headerJson.findIndex(header => header.key === "firstNameCc");
        const lastNameCcIndex = this.state.headerJson.findIndex(header => header.key === "lastNameCc");
        const companyNameIndex = this.state.headerJson.findIndex(header => header.key === "companyName");

        // 最大5件まで表示
        const itemsToShow = Math.min(displayLimit, totalCount);
        
        for (let i = 1; i <= itemsToShow; i++) { // 1から開始（0はヘッダー）
            const dataRow = csvFile[i];
            if (dataRow && dataRow.data) {
                const email = (mailAddressIndex >= 0) ? dataRow.data[mailAddressIndex] || "" : "";
                const firstName = (firstNameCcIndex >= 0) ? dataRow.data[firstNameCcIndex] || "" : "";
                const lastName = (lastNameCcIndex >= 0) ? dataRow.data[lastNameCcIndex] || "" : "";
                const companyName = (companyNameIndex >= 0) ? dataRow.data[companyNameIndex] || "" : "";
                
                const userName = (firstName && lastName) 
                    ? `${firstName} ${lastName}`
                    : firstName || lastName || "";
                
                csvItems.push([email, userName]);
            }
        }

        // 残りの件数を表示
        if (totalCount > displayLimit) {
            csvItems.push([this.sprintf(this.props.langText.Body.OtherCount, totalCount - displayLimit)]);
        }

        return csvItems;
    }

    getConfirmKeyItem = async (modalType) => {
        const {
            mailAddress,
            modalType: currentModalType,
            csvFile
        } = this.state;

        // ユーザー関連の処理の場合
        if (currentModalType === 'insert' || currentModalType === 'copy' || currentModalType === 'update' || currentModalType === 'delete') {
            return mailAddress;
        } else if (currentModalType === 'csvInsert') {
            const { csvFile, csvInsertData, user_affiliation_flag } = this.state;

            // 最大5件まで表示
            let csvItems = [];
            const displayLimit = 5; // 最大5件まで表示
            const totalCount = csvInsertData.length;
            const itemsToShow = Math.min(displayLimit, totalCount);
            
            
            // headerJsonからインデックスを取得
            const mailAddressIndex = this.state.headerJson.findIndex(header => header.key === "mailAddress");
            const firstNameCcIndex = this.state.headerJson.findIndex(header => header.key === "firstNameCc");
            const lastNameCcIndex = this.state.headerJson.findIndex(header => header.key === "lastNameCc");
            const companyNameIndex = this.state.headerJson.findIndex(header => header.key === "companyName");
            
            if(!user_affiliation_flag && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)){
                // ヘッダーを追加
                csvItems.push(["Email", "ユーザー名", "会社名"]);
                for (let i = 1; i <= itemsToShow; i++) { // 1から開始（0はヘッダー）
                    const dataRow = csvFile[i];
                    if (dataRow && dataRow.data) {
                        const email = (mailAddressIndex >= 0) ? dataRow.data[mailAddressIndex] || "" : "";
                        const firstName = (firstNameCcIndex >= 0) ? dataRow.data[firstNameCcIndex] || "" : "";
                        const lastName = (lastNameCcIndex >= 0) ? dataRow.data[lastNameCcIndex] || "" : "";
                        const companyName = (companyNameIndex >= 0) ? dataRow.data[companyNameIndex] || "" : "";
                        
                        const userName = (firstName && lastName) 
                            ? `${firstName} ${lastName}`
                            : firstName || lastName || "";
                        
                        csvItems.push([email, userName, companyName]);
                    }
                }
            } else {
                // ヘッダーを追加
                csvItems.push(["Email", "ユーザー名"]);
                for (let i = 1; i <= itemsToShow; i++) { // 1から開始（0はヘッダー）
                    const dataRow = csvFile[i];
                    if (dataRow && dataRow.data) {
                        const email = (mailAddressIndex >= 0) ? dataRow.data[mailAddressIndex] || "" : "";
                        const firstName = (firstNameCcIndex >= 0) ? dataRow.data[firstNameCcIndex] || "" : "";
                        const lastName = (lastNameCcIndex >= 0) ? dataRow.data[lastNameCcIndex] || "" : "";
                        
                        const userName = (firstName && lastName) 
                            ? `${firstName} ${lastName}`
                            : firstName || lastName || "";
                        
                        csvItems.push([email, userName]);
                    }
                }
            }
            // 残りの件数を表示
            if (totalCount > displayLimit) {
                csvItems.push([this.sprintf(this.props.langText.Body.OtherCount, totalCount - displayLimit)]);
            }
            return csvItems;
        }
    }

    render() {
        return (
            <div className='User'>
                <Row>
                    {
                        this.props.currentPermission.create
                        &&
                        <Col xs={12} md={12}>
                            <Button
                                id = "user-insert"
                                className = 'table-button'
                                bsStyle = 'default'
                                bsSize = 'sm'
                                onClick = {this.modalShow('insert')}
                            >
                                {this.props.langText.Body.InsertTitle}
                            </Button>
                            <Button
                                id="autoCallDetailList-csvInsert"
                                className="table-button"
                                bsStyle="default"
                                bsSize="sm"
                                onClick={this.modalShow("csvInsert")}>
                                {this.props.langText.Body.CsvImport}
                            </Button>

                            {this.props.currentPermission.export &&
                            <Col className="pull-right">
                                <div>
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            className='table-button'
                                            bsStyle='default'
                                            bsSize='sm'>
                                            {this.props.langText.Body.UserCsvExportListButton}
                                        </Dropdown.Toggle>
                                        <SettingMenu bsRole="menu">
                                            <Col>
                                                <Col xs={12} sm={12} md={12} lg={12} className="margin-top-10 margin-bottom-07">
                                                    <Col xs={2} sm={2} md={3} lg={3} className="text-align-left margin-top-05">
                                                        {this.props.langText.Body.CompanyName}
                                                    </Col>
                                                    {this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)
                                                        ?
                                                        <Col xs={10} sm={10} md={9} lg={9}>
                                                            <InlineForm
                                                                key = "csv_export_company_id"
                                                                controlId = "csv_export_company_id"
                                                                type = "select"
                                                                onChange = {e => this.onSelectChange(e, "csvExportCompanyId")}
                                                                options = {this.state.companySelect}
                                                                value = {this.state.csvExportCompanyId}
                                                                placeholder = {!this.state.buttondisabledArr.company_id[0]
                                                                    ? <Glyphicon glyph="refresh" className="spinning"/> : this.props.langText.SelectOption.Placeholder}
                                                                isDisabled = {!this.state.buttondisabledArr.company_id[0]}/>
                                                        </Col>
                                                        :
                                                        <Col xs={10} sm={10} md={9} lg={9} className="padding-top-05 padding-left-30">
                                                            {this.props.userInfo.company_name}
                                                        </Col>
                                                    }
                                                </Col>
                                                {
                                                    (
                                                        (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company) && this.state.csvExportDepartmentSelect.length > 0)
                                                        || !this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)
                                                    ) &&
                                                    <Col xs={12} sm={12} md={12} lg={12} className="margin-top-03 margin-bottom-07">
                                                        <Col xs={2} sm={2} md={3} lg={3} className="text-align-left margin-top-05">
                                                            {this.props.langText.Body.DepartmentName}
                                                        </Col>
                                                        {this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)
                                                            ?
                                                            <Col xs={10} sm={10} md={9} lg={9}>
                                                                <Col xs={12} sm={12} md={12} lg={12}>
                                                                    <MultiSelect
                                                                        hasSelectAll={true}
                                                                        options={this.state.csvExportDepartmentSelect}
                                                                        value = {this.state.csvExportDepartmentId}
                                                                        onChange={e => this.onMultiSelectChange(e, "csvExportDepartmentId")}
                                                                        filterOptions={this.createFilterOptions("csvExportDepartmentSelect", "csvExportDepartmentId")}
                                                                        overrideStrings={{
                                                                            selectSomeItems: this.props.langText.SelectOption.Placeholder,
                                                                            allItemsAreSelected: this.props.langText.Body.AllSelected,
                                                                            selectAll: this.props.langText.MultiSelect.AllSelect,
                                                                            search: this.props.langText.Body.Search,
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Col>
                                                            :
                                                            <Col xs={10} sm={10} md={9} lg={9} className="padding-top-05 padding-left-30">
                                                                {this.props.userInfo.department_name ? this.props.userInfo.department_name : ""}
                                                            </Col>
                                                        }
                                                    </Col>
                                                }
                                                {
                                                    (
                                                        (
                                                            this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department)
                                                            && (this.props.userInfo.floor_flg || this.state.floor_flg)
                                                            && (this.state.csvExportFloorSelect.length > 0)
                                                        )
                                                        || (!this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department) && this.props.userInfo.floor_flg)
                                                    ) &&
                                                    <Col xs={12} sm={12} md={12} lg={12} className="margin-top-03 margin-bottom-07">
                                                        <Col xs={2} sm={2} md={3} lg={3} className="text-align-left margin-top-05">
                                                            {this.props.langText.Body.FloorName}
                                                        </Col>
                                                        {this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department)
                                                            ?
                                                            <Col xs={10} sm={10} md={9} lg={9}>
                                                                <Col xs={12} sm={12} md={12} lg={12}>
                                                                    <MultiSelect
                                                                        hasSelectAll={true}
                                                                        options={this.state.csvExportFloorSelect}
                                                                        value = {this.state.csvExportFloorId}
                                                                        onChange={e => this.onMultiSelectChange(e, "csvExportFloorId")}
                                                                        filterOptions={this.createFilterOptions("csvExportFloorSelect", "csvExportFloorId")}
                                                                        overrideStrings={{
                                                                            selectSomeItems: this.props.langText.SelectOption.Placeholder,
                                                                            allItemsAreSelected: this.props.langText.Body.AllSelected,
                                                                            selectAll: this.props.langText.MultiSelect.AllSelect,
                                                                            search: this.props.langText.Body.Search,
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Col>
                                                            :
                                                            <Col xs={10} sm={10} md={9} lg={9} className="padding-top-05 padding-left-30">
                                                                {this.props.userInfo.floor_name ? this.props.userInfo.floor_name : ""}
                                                            </Col>
                                                        }
                                                    </Col>
                                                }{<Col xs={10} sm={10} md={9} lg={9}>
                                                    <label className="margin-top-05 margin-left-1 search-message">
                                                        {this.state.csvExportValidationMessage.map((row, key) =>
                                                            <p key={key}>{row}</p>
                                                        )}
                                                    </label>
                                                </Col>}
                                                <Col xs={12} sm={12} md={12} lg={12}
                                                    className="margin-top-07 margin-bottom-07 text-align-center margin-right-1">
                                                    <Col className="pull-right margin-right-15">
                                                        <Button
                                                            className='table-button'
                                                            bsStyle='default'
                                                            bsSize='sm'
                                                            onClick={this.createExportCsvData}
                                                            disabled = {this.state.csvExportValidationMessage.length > 0}>
                                                            {this.props.langText.Body.CSVExport}
                                                        </Button>
                                                        <CSVLink
                                                            data={this.state.csvExportData}
                                                            headers={this.state.csvHeaderExport}
                                                            filename={this.getCsvFileName()}
                                                            className="csv-download-link-format hidden"
                                                            ref={this.csvReaderRef}
                                                        />
                                                    </Col>
                                                </Col>
                                            </Col>
                                        </SettingMenu>
                                    </Dropdown>
                                </div>
                            </Col>}
                        </Col>
                    }
                    <Col xs={12} md={12}>
                        <CommonTable
                            talbeRef={this.table}
                            style={{height: this.props.tableHeight}}
                            manual = "manual"
                            columns = {this.state.columns}
                            data = {this.state.data}
                            pages = {this.state.pages}
                            loading = {this.state.loading}
                            defaultSorted={[{id: "id", desc: true}]}
                            onFetchData = {this.fetchData}
                            filtered={this.state.filtered}
                            filterable = {true}
                            previousText = {this.props.langText.Table.PreviousText}
                            nextText = {this.props.langText.Table.NextText}
                            loadingText = {this.props.langText.Table.LoadingText}
                            noDataText = {this.props.langText.Table.NoDataText}
                            rowsText = {this.props.langText.Table.RowsText}/>
                    </Col>
                    {this.state.errorMessageModalShow && (
                        <ErrorMessageModal
                            errorModalClose={this.errorModalClose}
                            state={this.state}
                            langText={this.props.langText}
                            errText={this.state.errText}
                        />
                    )}
                </Row>

                {/*モーダル表示分岐*/}
                {this.getModalBranch()}

                {/* 追加確認ポップアップ */}
                {
                    this.isTargetShowAddingConfirmationPopup &&
                    this.state.isSetShowAddingConfirmationPopup &&
                    <AscConfirm
                        state={
                            {
                                ...this.state,
                                show: this.state.showConfirm || false // showConfirmをshowに変換
                            }
                        }
                        key={this.state.modalType}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        charaLimit={this.props.charaLimit}
                        validationHandle={this.validationHandle}
                        onTextChange_Limit={this.onTextChange_Limit}
                        onClick={this.onClickHandle}
                        onClickCancelLockingBtn={this.onClickCancelLockingBtn}
                        sprintf={this.sprintf}
                        confirmKey={this.props.langText.Body.User}
                        confirmKeyItem={this.state.confirmKeyItem}
                        customBtn1Func = {this.onClickConfirm}
                    />
                }
            </div>
        )
    }
}

class SettingMenu extends React.Component {

    render() {
        const { children } = this.props;

        return (
            <Dropdown.Menu className="dropdown-menu-right user-csv-export-dropdown-menu">
                {React.Children.toArray(children)}
            </Dropdown.Menu>
        );
    }
}